// Survives a browser refresh: which form is open, and the values already
// typed into it, both scoped per form_id route so different practice links
// in the same browser don't clobber each other's in-progress state.
export const getOpenFormStorageKey = (routeFormId) =>
  `formZ.openFormId.${routeFormId}`;

export const getAnswersStorageKey = (routeFormId, formId) =>
  `formZ.answers.${routeFormId}.${formId}`;

export const readStorage = (key) => {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

export const writeStorage = (key, value) => {
  try {
    if (value === null || value === undefined) {
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.setItem(key, value);
    }
  } catch {
    // sessionStorage may be unavailable (e.g. private browsing) - the form
    // just won't survive a refresh in that case, nothing else to do.
  }
};

// Distinguishes an actual browser refresh (F5/reload button) from typing or
// clicking a URL - sessionStorage persists across both, but only a refresh
// should resume the in-progress form. A typed/clicked navigation must
// always land on the forms list, exactly like visiting for the first time,
// even if it's the same URL and even if a form was open before.
export const isPageRefresh = () => {
  try {
    const [entry] = performance.getEntriesByType("navigation");
    return entry ? entry.type === "reload" : false;
  } catch {
    return false;
  }
};
